export default __webpack_public_path__ + "static/media/rappi.7401aa2c.svg";